import noop from 'lodash/noop';
import { createActions } from 'redux-actions';
export const templatesActions = createActions({
    TEMPLATES_LIST_ALL: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TEMPLATES_ADD: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TEMPLATES_DELETE: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TEMPLATES_UPDATE: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TEMPLATES_RENDER: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TEMPLATES_SET_SORT: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TEMPLATES_GET_SORT: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
}, 'TEMPLATES_LIST_ALL_SUCCEEDED', 'TEMPLATES_LIST_ALL_FAILED', 'TEMPLATES_ADD_SUCCEEDED', 'TEMPLATES_ADD_FAILED', 'TEMPLATES_DELETE_SUCCEEDED', 'TEMPLATES_DELETE_FAILED', 'TEMPLATES_UPDATE_SUCCEEDED', 'TEMPLATES_UPDATE_FAILED', 'TEMPLATES_RENDER_SUCCEEDED', 'TEMPLATES_RENDER_FAILED', 'TEMPLATES_OPEN_CONFIRM_MODAL', 'TEMPLATES_CLOSE_CONFIRM_MODAL', 'TEMPLATES_OPEN_EDIT_MODAL', 'TEMPLATES_CLOSE_EDIT_MODAL', 'TEMPLATES_SET_SORT_SUCCEEDED', 'TEMPLATES_SET_SORT_FAILED', 'TEMPLATES_GET_SORT_SUCCEEDED', 'TEMPLATES_GET_SORT_FAILED');
